module.exports = __webpack_public_path__ + "media/site/images/products/bip-screen@2x-24fa81b8e3064f6162bc80d30e1c127b.png";